const errorMessages = {
  user: {
    exist: {
      title: 'Użytkownik istnieje',
      message: 'Użytkownik o podanym adresie email już istnieje',
    },
  },
  verification_code: {
    incorrect: {
      title: 'Nieprawidłowy kod',
      message: 'Wpisany kod jest nieprawidłowy',
    },
  },
};

const specificErrorMessagesForDedicatedUrl = {

};

export const prepareErrorMessageForNotAcceptableStatus = (errorData, errorUrl) => {
  // get only first error
  const mismatchValue = Object.keys(errorData)[0];
  const mismatchType = errorData[mismatchValue];

  return specificErrorMessagesForDedicatedUrl[errorUrl] || (errorMessages[mismatchValue]
    ? errorMessages[mismatchValue][mismatchType] : {
      title: 'Błąd',
      message: 'Wystąpił błąd podczas wykonywania operacji',
    });
};



// WEBPACK FOOTER //
// ./src/config/errorsMessages.js